import { useMemo } from "react";
import { ConfigProvider } from "antd";
import { ToastProvider, ThemeProvider, NotificationProvider } from "./context";
import { Provider, useSelector } from "react-redux";
import { store } from "./store";
import { getClientTheme } from "./store/slices/client";
import AppRouter from "./router";
import { useDirection, useDateLocale } from "./i18n/direction";
import { getCssVar, normalizeHexColor } from "./utility";
import "./index.css";

export default function App() {
  return (
    <Provider store={store}>
      <AppConfigProvider />
    </Provider>
  );
}

function AppConfigProvider() {
  const direction = useDirection();
  const locale = useDateLocale();
  const clientTheme = useSelector(getClientTheme);
  const themeTokens = useMemo(() => {
    const primary = normalizeHexColor(clientTheme.primaryColor) ?? getCssVar("--color-primary-60");
    return {
      colorPrimary: primary,
      colorPrimaryActive: primary,
      colorError: getCssVar("--color-font-danger"),
      colorWarning: getCssVar("--color-font-warning"),
    };
  }, [clientTheme]);
  return (
    <ConfigProvider
      direction={direction}
      locale={locale}
      theme={{
        token: {
          ...themeTokens,
          colorTextLabel: "var(--color-font-default)",
          colorIcon: "var(--color-icon-default)",
          colorTextPlaceholder: "var(--color-font-minimal)",
        },
        components: {
          Menu: {
            activeBarBorderWidth: 0,
            activeBarHeight: 0,
            itemColor: "var(--color-font-default)",
            itemHoverBg: "transparent",
            itemHoverColor: "var(--color-font-active)",
          },
          Tabs: {
            itemColor: "var(--color-font-minimal)",
            itemHoverColor: "var(--color-font-active)",
          },
          Segmented: {
            itemSelectedBg: "var(--color-background-primary-lighter) !important",
            itemSelectedColor: "var(--color-font-active)",
            itemColor: "var(--color-font-minimal)",
            itemHoverColor: "var(--color-font-active)",
          },
          DatePicker: {
            colorPrimary: "var(--color-font-active)",
            colorTextDisabled: "var(--color-font-disabled)",
            colorBgContainerDisabled: "var(--color-background-disabled)",
          },
          Breadcrumb: {
            lastItemColor: "var(--color-font-active)",
          },        },
      }}
    >
      <ToastProvider>
        <NotificationProvider>
          <ThemeProvider>
            <AppRouter />
          </ThemeProvider>
        </NotificationProvider>
      </ToastProvider>
    </ConfigProvider>
  );
}
